<template>
  <div id="hints-2">
    <BaseBanner v-bind="bannerProps" @onLoaded="onLoaded"></BaseBanner>

    <!-- Tutorial Overlay -->
    <TutorialOverlay
      v-if="tutorial.isActive.value"
      :current-step="tutorial.currentStep.value"
      :current-step-index="tutorial.currentStepIndex.value"
      :total-steps="tutorial.totalSteps.value"
      :target-rect="tutorial.targetRect.value"
      :is-first-step="tutorial.isFirstStep.value"
      :is-last-step="tutorial.isLastStep.value"
      @prev="tutorial.prevStep"
      @next="tutorial.nextStep"
      @go-to-step="tutorial.goToStep"
    />

    <!-- Wrong Page Popup -->
    <TutorialWrongPagePopup
      :show="tutorial.showWrongPagePopup.value"
      :page-name="tutorial.correctPageDisplayName.value"
      :target-component="tutorial.correctPageComponentName.value"
      @change-judge="handleChangeJudge"
    />

    <main
      class="content"
      :style="{
        'background-image': `url(${background.mainBg})`,
      }"
    >
      <div
        class="detail"
        v-for="(hint, index) in allHints"
        :key="index"
        @click="hint.is_used ? null : revealOneHint()"
      >
        <img
          :src="hint.is_used ? icon.unlockBlock : icon.hintBlock"
          class="detail__icon"
        />
        <template v-if="hint.is_used">
          <p
            v-if="hint.is_used"
            class="hint-text"
            v-html="changeLine(hint.content)"
          ></p>
        </template>
        <template v-else>
          <div class="item-text-unlock">給石獅一根潔牙骨</div>
        </template>
      </div>
    </main>
  </div>
</template>

<script>
import BaseBanner from '../../shared/baseBanner';
import { TutorialOverlay, TutorialWrongPagePopup } from '../../components/tutorial';
import { useHintsPage } from './useHintsPage';

/**
 * Refactored Hints page using composition API
 * Template structure matches original index.vue exactly to prevent style mismatch
 */
export default {
  name: 'HintsPage',

  components: {
    BaseBanner,
    TutorialOverlay,
    TutorialWrongPagePopup
  },

  props: ['memberLineId', 'memberName', 'groupId'],

  emits: ['change-judge'],

  setup(props, { emit }) {
    const hintsState = useHintsPage(props);

    const handleChangeJudge = (componentName) => {
      emit('change-judge', componentName);
    };

    return {
      ...hintsState,
      handleChangeJudge
    };
  }
};
</script>

<style lang="scss" scoped src="./style.scss"></style>
